import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { HashLink as Link } from 'react-router-hash-link';

import './header.css';

const content = require('../content.json');

class Header extends React.Component {
    render() {
        const className = cx('header', { header_transparent: this.props.isTransparent });
        const { style } = this.props;
        return (
            <div className={className} style={style}>
                <div className="header__container">
                    <div className="logos">
                        {content.logos.map((element) => (
                            <img
                                alt={`logo ${element}`}
                                className="logo"
                                key={element}
                                src={`./images/page/logos/${element}`}
                            />
                        ))}
                    </div>
                    <Link
                        className="menu-button"
                        to={{ pathname: '/menu', state: this.props.path }}
                    >
                        <div className="line" />
                        <div className="line" />
                        <div className="line" />
                    </Link>
                </div>
            </div>
        );
    }
}

Header.propTypes = {
    isTransparent: PropTypes.bool
};

export default Header;
